import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import type { ProjectUserResponse } from '@/domain/models/project.js';
import { useApp } from '@/presentation/hooks/use-app.js';

interface Props {
    techLeads: ProjectUserResponse[];
    selectedTechLeadId: string;
    currentTechLeadId: string | null;
    onSelectTechLead: (id: string) => void;
    assigningTechLead: boolean;
    assignTechLeadError: string | null;
    onAssign: () => void;
}

export function TechLeadAssignmentCard({ techLeads, selectedTechLeadId, currentTechLeadId, onSelectTechLead, assigningTechLead, assignTechLeadError, onAssign }: Props) {
    const { translate } = useApp();

    return (
        <Card variant="outlined">
            <CardContent>
                <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 2 }}>
                    {translate('estimate.assignTechLead')}
                </Typography>
                <Stack direction="row" spacing={1} alignItems="center" sx={{ maxWidth: 420 }}>
                    <TextField
                        select
                        label={translate('devDetail.techLead')}
                        value={selectedTechLeadId}
                        onChange={(e) => onSelectTechLead(e.target.value)}
                        size="small"
                        fullWidth
                        error={!!assignTechLeadError}
                    >
                        {techLeads.map((u) => (
                            <MenuItem key={u.id} value={u.id}>
                                {u.name}
                            </MenuItem>
                        ))}
                    </TextField>
                    <Button
                        variant="contained"
                        sx={{ color: 'white', whiteSpace: 'nowrap', flexShrink: 0 }}
                        onClick={() => onAssign()}
                        disabled={assigningTechLead || !selectedTechLeadId || selectedTechLeadId === currentTechLeadId}
                    >
                        {assigningTechLead ? translate('estimate.assigning') : translate('estimate.assignTechLead')}
                    </Button>
                </Stack>
                {assignTechLeadError && (
                    <Typography variant="caption" color="error" sx={{ display: 'block', mt: 1 }}>
                        {assignTechLeadError}
                    </Typography>
                )}
            </CardContent>
        </Card>
    );
}
